import styled from 'styled-components';
/* stylelint-disable block-no-empty */

var PopoverNavigationItem = styled.li.withConfig({
  displayName: "PopoverNavigationItem",
  componentId: "sc-1tc6p0q-0"
})([""]);
export default PopoverNavigationItem;